export default __webpack_public_path__ + "static/media/Step1-cto.7dc6edd1.svg";